import { render, staticRenderFns } from "./CorreoPreviewComponent.vue?vue&type=template&id=4fa74890&"
import script from "./CorreoPreviewComponent.vue?vue&type=script&lang=js&"
export * from "./CorreoPreviewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports